import { render } from "./UpdatePopup.vue?vue&type=template&id=3f29f466&scoped=true"
import script from "./UpdatePopup.vue?vue&type=script&lang=js"
export * from "./UpdatePopup.vue?vue&type=script&lang=js"

import "./UpdatePopup.vue?vue&type=style&index=0&id=3f29f466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f29f466"]])

export default __exports__